"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReconnectOverlay = ReconnectOverlay;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const networking_1 = require("~/networking");
const boardOverlay_1 = require("./boardOverlay");
function ReconnectOverlay() {
    const connectionStatus = (0, react_redux_1.useSelector)((state) => state.game.ui.connectionStatus);
    if (connectionStatus === networking_1.ConnectionStatus.NOT_CONNECTED ||
        connectionStatus === networking_1.ConnectionStatus.CONNECTED) {
        return null;
    }
    return (React.createElement(boardOverlay_1.BoardOverlay, null,
        React.createElement("div", null, connectionStatus === networking_1.ConnectionStatus.DISCONNECTED && (React.createElement(React.Fragment, null,
            React.createElement("p", null, "You've been disconnected - but you can get back in!"),
            React.createElement("p", null, "Please refresh the page to rejoin"))))));
}
